import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Grid, Paper, Box, Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    explanation: {
        marginTop: '1rem',
        padding: '.5rem',
        backgroundColor: '#88ba60',
        borderRadius: '20px'
    },
    image: {
        width: '40px',
        height: '50px'
    },
    item: {
        color: '#fff',
        fontSize: '20px'
    },
    icon: {
        display: 'inline-block',
        padding: '2px 12px',
        borderRadius: '5px',
        border: '2px solid #fff',
        fontSize: '1.3em',
        fontWeight: 'bold',
        margin: '0 5px'
    }
}));

// フローアイテム
function FlowItemB(props){
    const classes = useStyles();

    return(
        <Paper className={classes.explanation}>
            <Grid container>
                <Grid item xs={1}>
                    <img src="img/icon_memo.png" className={classes.image}/>
                </Grid>
                <Grid item xs={11}>
                    <Box className={classes.item}>
                        <div>
                            ②自筆証書遺言を作成せず
                        </div>
                        <div>
                            財産目録だけ作成される方は、
                        </div>
                        <div>
                            「財産目録作成に進む」をクリック
                        </div>
                    </Box>
                </Grid>
            </Grid>
        </Paper>
    );
}

export default FlowItemB
